import { aboutData, offeringsData, whyChooseData } from "../config/siteData";

const About = () => {
  return (
    <div>
      <section id="about" className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              What We <span className="text-purple-600">Offer</span>
            </h2>
            
            <div className="grid md:grid-cols-3 gap-8 mb-16">
              {offeringsData.map((offering, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{offering.title}</h3>
                  <p className="text-gray-600">{offering.description}</p>
                </div>
              ))}
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose The Kitchen:</h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                {whyChooseData.map((reason, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-purple-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">{reason}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="bg-gray-900 text-white p-12 rounded-2xl">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-4xl md:text-5xl font-bold mb-8">
                About <span className="text-purple-400">Us</span>
              </h2>
              
              <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                {aboutData.story}
              </p>
              
              <p className="text-xl text-purple-400 font-semibold mb-8">
                {aboutData.mission}
              </p>
              
              <div className="text-lg text-teal-400 font-semibold mb-10 uppercase tracking-wide">
                {aboutData.vibe}
              </div>
              
              <div className="grid md:grid-cols-5 gap-4">
                {aboutData.values.map((value, index) => (
                  <div key={index} className="bg-purple-600/20 p-4 rounded-lg border border-purple-500">
                    <span className="text-white font-medium">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;